import { GlobalCustomerUserConfigTradingLayoutArrangements } from '@talos/kyoko';
import type { MultiLayoutComponent } from '../../types';
import { CandlesticksAndMarketDataCardsArrangement } from './CandleSticksAndMarketDataCardsArrangement';
import { MarketDataCardsArrangement } from './MarketDataCardsArrangement';
import { SingleSymbolViewArrangement } from './SingleSymbolViewArrangement';
import { WatchlistAndMarketDataCardsArrangement } from './WatchlistAndMarketDataCardsArrangement';

export const SwapLayout: MultiLayoutComponent = {
  arrangements: {
    [GlobalCustomerUserConfigTradingLayoutArrangements.SingleSymbolView]: SingleSymbolViewArrangement, // Default Layout Arrangement
    [GlobalCustomerUserConfigTradingLayoutArrangements.MarketDataCards]: MarketDataCardsArrangement,
    [GlobalCustomerUserConfigTradingLayoutArrangements.CandlesticksAndMarketDataCards]:
      CandlesticksAndMarketDataCardsArrangement,
    [GlobalCustomerUserConfigTradingLayoutArrangements.WatchlistAndMarketDataCards]:
      WatchlistAndMarketDataCardsArrangement,
  },
};
